// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1iryL","box":"WorkspacesBox_box__Kqs-1","node":"WorkspacesBox_node__1CmZf"};